import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

type RoleAccessData = {
  allowRoles?: string[];
  denyRoles?: string[];
};

export const roleAccessGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const data = (route.data ?? {}) as RoleAccessData;
  const allowRoles = data.allowRoles ?? [];
  if (allowRoles.length > 0) {
    return authService.hasAnyRole(...allowRoles) ? true : router.createUrlTree(['/dashboard']);
  }
  const denyRoles = data.denyRoles ?? [];
  if (denyRoles.length > 0 && authService.hasAnyRole(...denyRoles)) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
};
